export const BASE_BUCKET_URL = 'https://construcaribe.s3.amazonaws.com/';
export const CLOUD_FRONT_URL = 'https://d3g47i6pg1qcj8.cloudfront.net/';
export const S3_BUCKET = "construcaribe";


export const LOGO = "/images/slogo.png"
